import React, { useState, useRef } from "react";
import { HiMenu } from "react-icons/hi";
import logo from "../assets/images/tas-logo.png";
import profile from "../assets/images/image.png";
import { Link } from "react-router-dom";
import {
  FiSearch,
  FiShoppingCart,
  FiHeart,
  FiDollarSign,
  FiUser,
  FiHelpCircle,
  FiSettings,
  FiLogOut,
} from "../assets/icons/vander";
import { createClient } from "../utils/supbase/client";
import { setUser } from "../redux/feature/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useGetUserProfileQuery } from "../redux/services/profile";

const Header = ({ toggleSidebar }) => {
  const user = useSelector((state) => state.auth.user);
  const {
    data: profile,
    error,
    isFetching: isLoading,
  } = useGetUserProfileQuery({ filter: { id: user.id } });

  const supabase = createClient();
  const dispatch = useDispatch();

  let userRef = useRef(null);

  let [userMenu, setUserMenu] = useState(false);

  const userOutsideClick = (e) => {
    if (userRef.current && !userRef.current.contains(e.target)) {
      setUserMenu(false);
    }
  };

  const handleLogout = async () => {
    let { error } = await supabase.auth.signOut();
    dispatch(setUser(null));
  };

  return (
    <header className="bg-white py-4 border-b-2 border-gray-200">
      <div className="container mx-auto px-6 flex items-center justify-between">
        {/* Menu Icon for mobile */}
        <div className="md:hidden">
          <button onClick={toggleSidebar}>
            <HiMenu className="text-2xl" />
          </button>
        </div>

        {/* Logo */}
        <div className="flex items-center space-x-4">
          <div className="text-2xl font-bold">
            <img src={logo} height={80} width={80} alt="Logo" />
          </div>
        </div>

        <div className="flex items-center space-x-6">
          {/* Notification Icon */}
          {/* <div className="relative">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="h-6 w-6 text-gray-600"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 00-5-5.917V5a2 2 0 10-4 0v.083A6 6 0 004 11v3.159c0 .538-.214 1.054-.595 1.436L2 17h5m3 0v1a3 3 0 006 0v-1m-6 0a3 3 0 006 0v-1"
              />
            </svg>
            <span className="absolute top-0 right-0 inline-block w-2 h-2 bg-red-600 rounded-full"></span>
          </div> */}

          {/* Profile Picture */}
          <div>
            <li className="dropdown inline-block relative ps-0.5" ref={userRef}>
              <button
                data-dropdown-toggle="dropdown"
                className="dropdown-toggle items-center"
                type="button"
                onClick={() => setUserMenu(!userMenu)}
              >
                <span className="size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full border border-orange-500 bg-orange-500 text-white">
                  <img
                    src={profile && profile[0]?.profile_image}
                    className="rounded-full"
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </span>
              </button>
              {userMenu && (
                <div className="dropdown-menu absolute end-0 m-0 mt-4 z-10 w-48 rounded-md overflow-hidden bg-white dark:bg-slate-900 shadow dark:shadow-gray-700">
                  <ul className="py-2 text-start">
                    <li className="ms-0">
                      <p className="text-slate-400 pt-2 px-4">
                        Welcome {profile && profile[0]?.user_name}!
                      </p>
                    </li>
                    <li className="ms-0">
                      <Link
                        to="/user-setting"
                        className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-orange-500 dark:hover:text-white"
                      >
                        <FiSettings className="h-4 w-4 me-2"></FiSettings>
                        Settings
                      </Link>
                    </li>
                    <li className="border-t border-gray-100 dark:border-gray-800 my-2"></li>
                    <li className="ms-0" onClick={handleLogout}>
                      <Link
                        to="/login"
                        className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-orange-500 dark:hover:text-white"
                      >
                        <FiLogOut className="h-4 w-4 me-2"></FiLogOut>Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
